import React from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, footer, size = "md" }) {
  if (!open) return null;
  const w = size === "lg" ? "max-w-2xl" : size === "sm" ? "max-w-sm" : "max-w-lg";
  return (
    <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center p-4 overflow-y-auto">
      <div className="absolute inset-0 bg-[#075E62]/40" onClick={onClose} />
      <div className={`relative z-10 w-full ${w} bg-white border border-[#D5E7E5] rounded-lg my-8`}>
        <div className="flex items-center justify-between px-6 h-14 border-b border-[#D5E7E5]">
          <h2 className="text-base font-medium text-[#075E62]">{title}</h2>
          <button onClick={onClose} data-testid="modal-close" className="text-[#5F8588] hover:text-[#075E62]"><X size={18} /></button>
        </div>
        <div className="p-6">{children}</div>
        {footer && <div className="px-6 py-4 border-t border-[#D5E7E5] flex justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}
